<template>
  <div class="hotel-nav">
    <HotelNavLink
      v-for="link in formattedLinks"
      :key="`hotel-menu-${link.text}`"
      :element="link.element"
      :link="link.link"
      :text="link.text"
      :icon="link.icon"
    />
  </div>
</template>

<script>
/** ================================================
 * MENU DE NAVEGAÇÃO INTERNA DO HOTEL
 * ================================================= */
import HotelNavLink from './HotelNavLink'

export default {
  name: 'HotelNav',
  components: {
    HotelNavLink
  },
  props: {
    /**
     * Links do menu
     * @example [{ text: 'hotel', link: '/detalhe', icon: 'icon', element: 'a' }]
     *
     * @param {String} element tipo de elemento que deve ser renderizado pelo Vue, <a> ou <router-link>
     * @param {String} icon nome do ícone
     */
    links: {
      type: Array,
      required: true
    },
    /** Itens que devem ser escondidos no menu */
    hide: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    /** Formatar os links do menu, remover o itens necessários */
    formattedLinks() {
      return this.links.filter((link) => !this.hide.includes(link.class))
    }
  }
}
</script>

<style lang="scss" scoped>
.hotel-nav {
  display: flex;
  justify-content: center;
  margin: 45px auto 40px;
}
</style>
